<template>
  <div class="box body-bg">
    <div class="content">
      <div class="item header">
        DBAPI
      </div>
      <div class="item">
        <el-input v-model="username" :placeholder="$t('m.username')"></el-input>
      </div>
      <div class="item">
        <el-input v-model="password" :placeholder="$t('m.password')" type="password"></el-input>
      </div>
      <div class="item">
        <div class="buttton" @click="login">{{$t('m.login')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: null,
      password: null

    }
  },
  methods: {
    login() {
      console.log(parseFloat(-1000))
      this.axios.post("/user/login", {username: this.username, password: this.password}).then((response) => {
        if (response.data.success) {
          localStorage.setItem("token", response.data.msg)
          this.$router.push("/api")
        } else {
          this.$message.error(response.data.msg)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
      // localStorage.setItem("token", 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzeXNhZG1pbkBodWFuc2kubmV0IiwidXNlcklkIjoiODUwODg3NTAtMWVhMS0xMWVkLWE4YmUtNzEyMzk1NjEyNDRlIiwic2NvcGVzIjpbIlNZU19BRE1JTiJdLCJpc3MiOiJ0aGluZ3Nib2FyZC5pbyIsImlhdCI6MTY3ODk1MjQxMywiZXhwIjoxNjc4OTYxNDEzLCJlbmFibGVkIjp0cnVlLCJpc1B1YmxpYyI6ZmFsc2UsInRlbmFudElkIjoiMTM4MTQwMDAtMWRkMi0xMWIyLTgwODAtODA4MDgwODA4MDgwIiwiY3VzdG9tZXJJZCI6IjEzODE0MDAwLTFkZDItMTFiMi04MDgwLTgwODA4MDgwODA4MCJ9.vVptUbwVwb9SllFsE0J1cUbG_d6IDeeZbcChTnxLz_rt-EcspiNiACuMrraRWC52PmOJGxkDXgPrJm3Pj2jlmA')
      // this.$router.push("/api")
    }
  },
  created() {
    document.onkeydown = (e) => {
      const key = window.event.keyCode;
      if (key == 13 || key == 100) {
        this.login()
      }
    }
  },
  destroyed() {
    document.onkeydown = null
  }
}
</script>

<style scoped>
.box {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /*margin-top: 200px;*/
}

.content {
  /*box-shadow: 10px 10px 5px #888888;*/
  /*margin-top: -100px;*/
  padding-bottom: 100px;
}

.item {
  width: 400px;
  height: 70px;
} 

.buttton {
  width: 400px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #c13232;
  border-radius: 10px;
  color: #ffffff;
  font-weight: 700;
  font-size: 20px;
}


.header {
  text-align: center;
  color: #c13232;
  font-weight: 700;
  font-size: 40px;
}

.buttton:hover {
  background-color: #07a863;
  font-size: 21px;
  cursor: pointer;
}

.body-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: #c7edcc;
}
</style>